import React from 'react';

interface FilterStatusCellProps {
  status: boolean;
}

const FilterStatusCell: React.FC<FilterStatusCellProps> = ({ status }) => {
  const getStatusColor = (status: boolean) => {
    return status 
      ? 'bg-green-100 text-green-800' 
      : 'bg-yellow-100 text-yellow-800';
  };

  const getStatusText = (status: boolean) => {
    return status ? 'Ok' : 'No';
  };

  return (
    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(status)}`}>
      {getStatusText(status)}
    </span>
  );
};

export default FilterStatusCell; 